import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { commentsApi, Comment, type CommentScope } from '../api/commentsApi';

const REPLICATION_REGEX = /\[FROM\s+[A-Z]+-\d+\]\s*/;

export const useIssueComments = (issueKey: string, scope: CommentScope = 'user') => {
  const {
    data: comments = [],
    isLoading,
    error,
  } = useQuery<Comment[]>({
    queryKey: ['comments', issueKey, scope],
    queryFn: () => commentsApi.fetchComments(issueKey, scope),
    enabled: !!issueKey,
  });

  const cleanedComments = useMemo(() =>
    comments.map(comment => ({
      ...comment,
      text: comment.text?.replace(REPLICATION_REGEX, '') || '',
    })),
    [comments]
  );

  return {
    comments: cleanedComments,
    isLoading,
    error: error as Error | null,
  };
};
